function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { useApp } from "../../a";
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'social-media-button';
const defaultsMap = {
  facebook: {
    icon: 'f',
    link: 'FACEBOOK'
  },
  instagram: {
    icon: 'i',
    link: 'INSTAGRAM'
  },
  twitter: {
    icon: 't',
    link: 'TWITTER'
  },
  linkedin: {
    icon: 'l',
    link: 'LINKEDIN'
  },
  threads: {
    icon: 'u',
    link: 'THREADS'
  }
};

/**
 * This is the component description.
 * This component takes `y` as the default color and `x` as the hover color.
 * This components needs to be wrapped within a `AppContextProvider`.
 */
const SocialMediaButton = ({
  id,
  className: userClassName,
  style,
  type,
  icon,
  link,
  color,
  isTransparent,
  ...otherProps
}) => {
  const applicationContext = useApp();
  const content = type && defaultsMap[type];
  const href = link || applicationContext?.SOCIAL?.[content?.link];
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("button", _extends({
    id: id,
    className: [baseClassName, `x-${color || type}`, isTransparent && styleNames.modifierTransparent, componentClassName, userClassName].filter(e => e).join(' '),
    style: style,
    type: "button"
  }, otherProps), icon || content.icon));
};
SocialMediaButton.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * The Social Media to Target.
   * If blank, you need to provide both an icon letter (from glyphter) and a link.
   */
  type: PropTypes.oneOf(['twitter', 'facebook', 'instagram', 'linkedin']),
  /**
   * The icon of the social media
   */
  icon: PropTypes.string,
  /**
   * The link to the social media
   */
  link: PropTypes.string,
  /**
   * The button color
   */
  color: PropTypes.string,
  /**
   * Whether the button is transparent
   */
  isTransparent: PropTypes.bool
};
SocialMediaButton.defaultProps = {
  // someProp:false
};
export default SocialMediaButton;